// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import Address from "./types/address";
import SignedState from "./SignedState";

@jsonObject
export default class RecoverFunds extends PerunMessage {
  @jsonMember(SignedState) signedState: SignedState;


  constructor(signedState: SignedState) {
    super();
    this.signedState = signedState;
  }

  messageType(): MessageType {
    return RecoverFunds;
  }

  messageTypeName(): MessageTypeName {
    return "RecoverFunds";
  }
}
